export default __webpack_public_path__ + "static/media/error_icon.ee747f16.svg";